import { ApplicationTags } from 'constants/enums';

import { TranslationKey } from '../../../../types/i18next';

const ApplicationTagsTitleMapping: Partial<
  Record<ApplicationTags, TranslationKey>
> = {
  [ApplicationTags.AcceptedApplicationStageOfferLetterGiven]:
    'application.title.awaitingResponse',
  [ApplicationTags.AcceptedApplicationStageOfferLetterSigned]:
    'application.title.offerAccepted',
  [ApplicationTags.DeclinedApplicationStageJobseekerRefused]:
    'application.title.offerDeclined',
  [ApplicationTags.DeclinedApplicationStageWithdrawn]:
    'application.title.offerCanceled'
};

const DEFAULT_TITLE: TranslationKey = 'application.title.default';
const SENDING_OFFER_TITLE: TranslationKey = 'application.title.send';

export const getTitle = (
  applicationTags: string[] | null | undefined,
  isSendingOffer: boolean,
  isDeclinedApplicationStage: boolean
): TranslationKey => {
  if (isDeclinedApplicationStage) {
    return 'application.title.offerDeclined';
  }

  if (isSendingOffer) {
    return SENDING_OFFER_TITLE;
  }

  if (!applicationTags?.length) {
    return DEFAULT_TITLE;
  }

  const matchingTag = Object.keys(ApplicationTagsTitleMapping).find((tag) =>
    applicationTags.includes(tag)
  );

  return matchingTag
    ? (ApplicationTagsTitleMapping[
        matchingTag as keyof typeof ApplicationTagsTitleMapping
      ] as TranslationKey)
    : DEFAULT_TITLE;
};
